export default "__VITE_ASSET__bb4o60$Z__"